import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../manage.css";

const AddUser = () => {
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    role: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          "https://api.arkiva.gov.al/api/roles",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setRoles(response.data);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "Emri nuk mund të jetë bosh!";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Mbiemri nuk mund të jetë bosh!";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email nuk mund të jetë bosh!";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Email jo i saktë!";
      }
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Numri i telefonit nuk mund të jetë bosh!";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Passwordi nuk mund të jetë bosh!";
    } else if (formData.password.length < 8) {
      newErrors.password = "Passwordi duhet të ketë të paktën 8 karaktere!";
    }

    if (!formData.role) {
      newErrors.role = "Zgjidhni një rol!";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.post(
        "https://api.arkiva.gov.al/api/users/create",
        {
          firstName: formData.firstName.trim(),
          lastName: formData.lastName.trim(),
          email: formData.email.trim(),
          phone: formData.phone.trim(),
          password: formData.password,
          role: formData.role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data) {
        navigate("/manage/users");
      }
    } catch (error) {
      console.error("Error creating user:", error);

      if (error.response?.status === 409) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email:
            error.response.data.message ||
            "Ekziston një përdorues me këtë email.",
        }));
      } else {
        alert(
          error.response?.data?.message ||
            "Ndodhi një gabim gjatë krijimit të përdoruesit.",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/manage/users");
  };

  return (
    <div className="edit-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="return">
        <button type="button" onClick={handleCancel}>
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      </div>

      <p>Shto Përdorues</p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="firstName">Emri</label>

          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
          />

          {errors.firstName && (
            <small className="error">{errors.firstName}</small>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="lastName">Mbiemri</label>

          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />

          {errors.lastName && (
            <small className="error">{errors.lastName}</small>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>

          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />

          {errors.email && <small className="error">{errors.email}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="phone">Telefon</label>

          <input
            type="text"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />

          {errors.phone && <small className="error">{errors.phone}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="password">Password i përkohshëm</label>

          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
          />

          {errors.password && (
            <small className="error">{errors.password}</small>
          )}

          <small>
            Përdoruesi do të kërkohet ta ndryshojë këtë password në hyrjen e
            parë.
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="role">Roli</label>

          <select
            id="role"
            name="role"
            value={formData.role}
            onChange={handleChange}
          >
            <option value="">Zgjidh rolin</option>

            {roles.map((role) => (
              <option key={role._id} value={role._id}>
                {role.name}
              </option>
            ))}
          </select>

          {errors.role && <small className="error">{errors.role}</small>}
        </div>

        <div className="edit-actions">
          <button type="submit" className="save" disabled={loading}>
            Shto Përdorues
          </button>

          <button
            type="button"
            className="cancel"
            onClick={handleCancel}
            disabled={loading}
          >
            Anullo
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
